import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Container, Row } from 'react-bootstrap';
import CircledIcon from '../../../../components/CircledIcon';
import GenericCard from '../../../../components/GenericCards/GenericCards';
import GenericList, {
  GenericListItem,
} from '../../../../components/GenericList';
import Link from '../../../../components/Link';
import { OPTIMIZER_ROUTE } from '../../../../routes/types';

const toolsOptions = [
  {
    title: 'Find a Doctor/Hospital',
    iconR: light('up-right-from-square'),
    iconCircle: light('user-doctor'),
    url: 'https://qabtr.lifeatworkportal.com/dst/findprovider/?dataoverride=1',
    target: '_blank',
  },

  {
    title: 'Compare Plans & Costs',
    iconR: light('up-right-from-square'),
    iconCircle: light('scale-balanced'),
    url: 'https://start.myalex.com/placeholder-industries/',
    target: '_blank',
  },

  {
    title: 'Calculate HSA Needs',
    iconR: light('up-right-from-square'),
    iconCircle: light('calculator'),
    url: 'https://qabtr.lifeatworkportal.com/dst/bw_hsalimitOE/?Disclaimer=0',
    target: '_blank',
  },

  {
    title: 'Calculate FSA Needs',
    iconR: light('up-right-from-square'),
    iconCircle: light('calculator'),
    url: 'https://btr.lifeatworkportal.com/dst/fsa/default.aspx',
    target: '_blank',
  },

  {
    title: 'Calculate Life Insurance Needs',
    iconR: light('up-right-from-square'),
    iconCircle: light('calculator'),
    url: 'https://btr.lifeatworkportal.com/dst/life/default.aspx',
    target: '_blank',
  },

  {
    title: 'Optimizer Tool',
    iconR: light('up-right-from-square'),
    iconCircle: light('wrench-simple'),
    url: `#${OPTIMIZER_ROUTE}`,
  },
];

const genericListContent = [
  {
    linkTitle: 'Give Your Child a Smart Start',
    linkRIcon: light('arrow-up-right-from-square'),
    linkLIcon: light('family'),
    url: '#',
    target: '_blank',
  },

  {
    linkTitle: 'Financial Wellness Resources',
    linkRIcon: light('arrow-up-right-from-square'),
    linkLIcon: light('scale-balanced'),
    url: '#',
    target: '_blank',
  },

  {
    linkTitle: 'Asset Allocation 101',
    linkRIcon: light('arrow-up-right-from-square'),
    linkLIcon: light('chart-pie'),
    url: '#',
    target: '_blank',
  },

  {
    linkTitle: 'Do I Need Long-Term Care Insurance',
    linkRIcon: light('arrow-up-right-from-square'),
    linkLIcon: light('briefcase-medical'),
    url: '#',
    target: '_blank',
  },

  {
    linkTitle: 'Identity Theft Protection',
    linkRIcon: light('arrow-up-right-from-square'),
    linkLIcon: light('memo-circle-info'),
    url: '#',
    target: '_blank',
  },

  {
    linkTitle: 'Tax Guidelines for HSAs',
    linkRIcon: light('arrow-up-right-from-square'),
    linkLIcon: light('bed-pulse'),
    url: '#',
    target: '_blank',
  },
];

function Tools() {
  return (
    <Container className={'px-0'}>
      <Row sm={1} className={'mx-0'}>
        <Col className={'px-0 mx-0 col-lg-8'}>
          <Row className={'row-cols-lg-2 mx-0'}>
            {toolsOptions.map((genericCard, idx) => {
              return (
                <Container key={idx} className={'px-0 pe-lg-7 pe-sm-0'}>
                  <GenericCard className={'p-7 mt-7'} variant={'white'}>
                    <Container className={'d-flex align-items-center px-0'}>
                      <CircledIcon
                        variant="icon-emphasized"
                        icon={genericCard.iconCircle}
                      />
                      <Container className={'w-100 px-0 ms-7'}>
                        <Link
                          rightIcon={genericCard.iconR}
                          isBlue
                          isAlignAtEnd
                          href={genericCard.url}
                          target={genericCard.target}
                        >
                          <h6 className="text-fs-6 mb-0 fw-normal">
                            {genericCard.title}
                          </h6>
                        </Link>
                      </Container>
                    </Container>
                  </GenericCard>
                </Container>
              );
            })}
          </Row>
        </Col>

        <Col lg={true} className={'px-0'}>
          <Container className={'px-0'}>
            <GenericCard className={'mt-7'} variant={'white'}>
              <GenericList>
                <h6 className={'fs-10'}>Additional Materials</h6>

                {genericListContent.map((genericListItem, idx) => {
                  return (
                    <GenericListItem key={idx}>
                      <Link
                        rightIcon={genericListItem.linkRIcon}
                        leftIcon={genericListItem.linkLIcon}
                        eventKey="test"
                        isAlignAtEnd
                        isBlue
                        isBlueIcon
                        className={'py-0'}
                        href={genericListItem.url}
                        target={genericListItem.target}
                      >
                        {genericListItem.linkTitle}
                      </Link>
                    </GenericListItem>
                  );
                })}
              </GenericList>
            </GenericCard>
          </Container>
        </Col>
      </Row>
    </Container>
  );
}

export default Tools;
